import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const AvailabilityHero = () => {
  return (
    <Wrapper>
      <StaticImage
        className="img"
        src="../../assets/images/availability-hero.jpg"
        layout="constrained"
        alt="contacto"
        placeholder="blurred"
      />
      <h1>Escríbenos</h1>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  width: 100%;
  position: relative;
  .img {
    height: 408px;
  }

  h1 {
    color: var(--white);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`

export default AvailabilityHero
